import { render, staticRenderFns } from "./EditAllTopicsForStudentDialog.vue?vue&type=template&id=1ddddeb2"
import script from "./EditAllTopicsForStudentDialog.ts?vue&type=script&lang=ts&external"
export * from "./EditAllTopicsForStudentDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./EditAllTopicsForStudentDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports